import React from 'react'

import { EducatorsAndTransformingSchools } from '@components/cases/EducatorsAndTransformingSchools'
import { CustomHead } from '@ui/sections/CustomHead'

function StaffAugmentationServicesForEducationSoftwareDevelopment() {
  return (
    <>
      <CustomHead
        title="Team augmentation services for education platform development"
        description="Follow the step-by-step IT staff augmentation process for EdTech solution development established at Modsen."
        imagePath="/images/custom-head/custom-head-staff-augmentation-services-for-education.webp"
      />
      <EducatorsAndTransformingSchools />
    </>
  )
}

export default StaffAugmentationServicesForEducationSoftwareDevelopment
